export default __webpack_public_path__ + "img/JOeDBJSA.b15bfeb6.svg";